/* filters
========================================================================== */
let selectedFilters = {
    c: [],
    t: [],
    s: []
};
function setSelectedFilters(links) {
    links.forEach((link) => {
        const linkType = link.dataset.type;
        let linkUuid = '';
        if (link.dataset.uuid) {
            linkUuid = link.dataset.uuid;
        }
        else if (link.dataset.uuids) {
            linkUuid = JSON.parse(link.dataset.uuids);
        }
        if (link.classList.contains('is-selected')) {
            if (Array.isArray(linkUuid)) {
                linkUuid.forEach((uuid) => {
                    selectedFilters[linkType].push(uuid);
                });
            }
            else {
                selectedFilters[linkType].push(linkUuid);
            }
        }
    });
}
function selectFilter(e) {
    e.preventDefault();
    const link = e.currentTarget;
    const linkType = link.dataset.type;
    let linkUuid = '';
    if (link.dataset.uuid) {
        linkUuid = link.dataset.uuid;
    }
    else if (link.dataset.uuids) {
        linkUuid = JSON.parse(link.dataset.uuids);
    }
    if (link.classList.contains('is-selected')) {
        link.classList.remove('is-selected');
        let typedLinks = [];
        if (Array.isArray(linkUuid)) {
            typedLinks = selectedFilters[linkType].filter((uuid) => {
                return !linkUuid.includes(uuid);
            });
        }
        else {
            typedLinks = selectedFilters[linkType].filter((uuid) => {
                return uuid !== linkUuid;
            });
        }
        selectedFilters[linkType] = typedLinks;
    }
    else {
        link.classList.add('is-selected');
        if (Array.isArray(linkUuid)) {
            linkUuid.forEach((uuid) => {
                selectedFilters[linkType].push(uuid);
            });
        }
        else {
            selectedFilters[linkType].push(linkUuid);
        }
    }
}
function updateLink(link) {
    let linkBase = link.dataset.linkBase;
    const linkTypes = Object.keys(selectedFilters);
    linkTypes.forEach((type) => {
        selectedFilters[type].forEach((uuid) => {
            if (linkBase === link.dataset.linkBase) {
                linkBase += '?';
            }
            else {
                linkBase += '&';
            }
            linkBase += `${type}[]=${uuid}`;
        });
    });
    link.setAttribute('href', encodeURI(linkBase));
}
export default function addFilters() {
    const filters = document.querySelectorAll('[data-component="filters"]');
    filters.forEach((el) => {
        const links = el.querySelectorAll('[data-filters-target="link"]');
        const searchLink = el.querySelector('[data-filters-target="search"]');
        setSelectedFilters(links);
        updateLink(searchLink);
        links.forEach((link) => {
            link.addEventListener('click', (e) => {
                selectFilter(e);
                updateLink(searchLink);
            });
        });
    });
}
